import type { JSX } from "react";
import { Navigate } from "react-router-dom";

import { useHasDuty } from "../auth/BackofficeDutyProvider";

/*
 * What /bolon shows: the dashboard for an admin, Orders for everyone else.
 *
 * A component rather than a `<Navigate>` in the route table, because the
 * decision needs the duty context — which only exists INSIDE the provider
 * mounted by this route's own parent element (BolonLayout).
 *
 * Staff are REDIRECTED to their own work rather than shown Access denied. This
 * is the one route every signed-in user lands on, so refusing it would greet
 * every staff login with a wall — a redirect takes them where they were going
 * anyway. Every other manager-only route still renders Access denied, because
 * reaching those means following a link or typing a URL, and silently
 * bouncing that is more confusing than saying no.
 *
 * `replace` so the dashboard URL does not linger in history: without it, a
 * staff user pressing Back lands on /bolon, is redirected again, and cannot
 * leave.
 *
 * The dashboard element is passed in by the router so it can stay lazy.
 */
export function BolonLanding({ dashboard }: { dashboard: JSX.Element }) {
  const canSeeDashboard = useHasDuty("dashboard");
  return canSeeDashboard ? dashboard : <Navigate replace to="/bolon/orders" />;
}
